// ═══ 데스크톱 우측 사이드 카드 — 시안 C1 `.rcol .card` (신고 371 §8) ═══
// SimpleCard(제목·카운트·우측 슬롯·본문) 를 그대로 쓰되, 사이드 카드가 모두 갖는
// '전체 보기 ›' 링크만 공용화한다. 링크가 없으면 SimpleCard 를 직접 써도 결과가 같다.
// props: { title, count, linkLabel, onLink, right, pad, style, children }
import React from 'react';
import { T } from '../../theme';
import SimpleCard from './SimpleCard';

var link = { display: 'inline-flex', alignItems: 'center', gap: 4, border: 0, background: 'none', padding: 0,
  fontFamily: 'inherit', fontSize: 11.5, fontWeight: 700, color: T.accentPress, cursor: 'pointer' };
var chev = { flex: 'none' };

function SideCard(props) {
  var right = props.linkLabel ? (<button type="button" className="ss-sidecard-link" style={link} onClick={props.onLink}>
    {props.linkLabel}
    <svg className="ss-flipx" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" style={chev} aria-hidden="true" focusable="false">
      <path d="M9.5 5.5l6.5 6.5-6.5 6.5" />
    </svg>
  </button>) : props.right;

  return (<SimpleCard title={props.title} count={props.count} right={right}
    pad={props.pad} style={props.style}>{props.children}</SimpleCard>);
}

export default SideCard;
